import { VueModule } from '@Foundation/utilities';
import CountrySwitcher from './code/Scripts/components/country-switcher.vue';

export default VueModule({
  components: {
    CountrySwitcher
  }
});
